/**
 * Selecciona la cámara con la mayor calidad disponible.
 * Prioriza la cámara trasera (environment) en móviles para AR.
 */
export async function getBestCameraDevice() {
  if (!navigator.mediaDevices?.enumerateDevices) return null;

  const devices = await navigator.mediaDevices.enumerateDevices();
  const videoDevices = devices.filter((d) => d.kind === 'videoinput');

  if (videoDevices.length === 0) return null;
  if (videoDevices.length === 1) return videoDevices[0].deviceId;

  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  const prefersBack = isMobile;

  if (prefersBack) {
    const backCamera = videoDevices.find(
      (d) =>
        d.label.toLowerCase().includes('back') ||
        d.label.toLowerCase().includes('rear') ||
        d.label.toLowerCase().includes('environment') ||
        d.label.toLowerCase().includes('trasera')
    );
    if (backCamera) return backCamera.deviceId;
  }

  return videoDevices[0].deviceId;
}

/** 720p: más rápido para detección de marcador (menos píxeles por frame) */
export const VIDEO_CONSTRAINTS_FAST = {
  width: { ideal: 1280 },
  height: { ideal: 720 },
};

export const VIDEO_CONSTRAINTS_HIGH = {
  width: { ideal: 1920 },
  height: { ideal: 1080 },
};

export const VIDEO_CONSTRAINTS_BEST = {
  width: { ideal: 3840 },
  height: { ideal: 2160 },
};
